import { TabbedEditor } from './TabbedEditor';
import { usePopOutEditorState, usePopOut } from '../../../pop-out/public/hooks';
import { EditorModal } from '../../../pop-out/public/components';
import { useLayoutEffect } from 'react';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const teleportOptions = {
  elementConstructor() {
    const e = document.createElement('div');
    e.classList.add('popout-editor-teleporter');
    e.classList.add('display-flex');
    e.classList.add('flex-grow-1');
    return e;
  }
};
const TeleporterHomeLocation = styled.div.withConfig({
  displayName: "ExpandableTabbedEditor__TeleporterHomeLocation",
  componentId: "ehdgqc-0"
})(["display:flex;flex-grow:1;.popout-editor-teleporter{min-inline-size:100px;}"]);

/**
 * Render the TabbedEditor inside of a Portal, if the exitor is in the expanded state.
 * @param props Passed through to <TabbedEditor/>
 * @returns
 */
export function ExpandableTabbedEditor(props) {
  const {
    isOpen,
    ref
  } = usePopOutEditorState('replyEditor');
  const component = /*#__PURE__*/_jsx(TabbedEditor, Object.assign({}, props, {
    expandable: true
  }));
  const [portal, popOut, reset] = usePopOut(component, teleportOptions);
  useLayoutEffect(() => {
    if (isOpen && ref) {
      popOut(ref);
    } else {
      reset();
    }
  }, [isOpen, ref, reset, popOut]);
  return /*#__PURE__*/_jsxs(TeleporterHomeLocation, {
    children: [portal, /*#__PURE__*/_jsx(EditorModal, {
      editorKey: "replyEditor"
    })]
  });
}
ExpandableTabbedEditor.displayName = 'ExpandableTabbedEditor';